import script from "./PasswordRequirementsChecker.vue?vue&type=script&lang=ts&setup=true"
export * from "./PasswordRequirementsChecker.vue?vue&type=script&lang=ts&setup=true"

import "./PasswordRequirementsChecker.vue?vue&type=style&index=0&id=f63b4634&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./locale/PasswordRequirementsChecker.yaml?vue&type=custom&index=0&blockType=i18n&issuerPath=C%3A%5CJenkins%5Cworkspace%5CPlatformIdentity_master%5Cfrontend%5Cshared%5Cvue%5CPasswordRequirementsChecker.vue&lang=yaml&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f63b4634"]])

export default __exports__